import React, { useState } from 'react';
import drupalData from './DrupalData';
import VideoModal from '../components/VideoModal';

export const DrupalDemoPage = () => {

    const [searchValue, setSearchValue] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [open, setOpen] = useState(false);
    const [demoData, setDemoData] = useState();

    const handleOpen = (videoData) => {
        setDemoData(videoData);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const url = new URL(window.location.href);

    const filterCards = (data, value) => {
        if (!value.trim()) return [];
        return data.filter(card =>
            card.text.toLowerCase().includes(value.toLowerCase()) ||
            (card.tags && card.tags.some(tag => tag.toLowerCase().includes(value.toLowerCase())))
        );
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);

        if (!value.trim()) {
            setSearchResults([]);
            return;
        }

        const filtered = filterCards(drupalData, value);
        setSearchResults(filtered);
    };

    const displayedCards = searchValue.trim() ? searchResults : drupalData;

    return (
        <>
            <div className="backButton d-flex align-items-center mx-2 my-3" onClick={() => window.location.href = `${url.origin}/demo`}>
                <span className="material-symbols-rounded text-dark">keyboard_arrow_left</span>
                <p className="mb-0">Back to main page</p>
            </div>

            <div className='w-100 bg-light px-5'>
                <div className='row justify-content-between align-items-center w-100 py-4 px-5'>
                    <div className='col-6'>
                        <h4 className='text-start mt-2 h-auto lh-base text-secondary-emphasis fw-bold mx-4 mx-md-0 mt-4 mt-md-0'>Drupal</h4>
                        <h5 className='text-start mb-md-3 h-auto text-secondary'>Securing the most secure CMS</h5>
                    </div>
                    <div className='col-4'>
                        <input className="form-control p-3" placeholder="Search" onChange={handleSearchChange} />
                    </div>
                </div>
            </div>

            <div className="mt-5 px-0 px-sm-5">
                <div className="row g-4">
                    {displayedCards.map((item, index) => (
                        <div key={index} className="col-sm-12 col-md-6 col-lg-4">
                            <div className="custom-shadow d-flex border rounded-3 px-3 py-4 align-items-center" onClick={() => handleOpen(item)}>
                                <div className="align-items-center text-14">
                                    <div className="d-flex justify-content-center bg-primary align-items-center me-3 rounded-circle" style={{ height: "40px", width: "40px", background: "#082544" }}>
                                        {item.icon}
                                    </div>
                                </div>
                                <div className='d-flex flex-column'>
                                    <span style={{ fontWeight: 500, fontSize: '17px' }}>{item.text}</span>
                                    <span className='font-14 fw-normal' style={{ color: "#a7a7a7" }}>{item?.desc}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {open &&
                <VideoModal
                    open={open}
                    handleOpen={handleOpen}
                    handleClose={handleClose}
                    videoData={demoData}
                />
            }
        </>
    );
};
